import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCustomerOrderReportQuery, useSalesReportQuery } from '../../../../Store/Apis/reportApi';
import Error from '../../../../Components/Error/Error';
import Loader from '../../../../Components/Loader/Loader';
import { useOutletsQuery } from '../../../../Store/Apis/outletApi';
import { useStatusQuery } from '../../../../Store/Apis/bookingApi';
import getStatusColor from '../../../../Hooks/GetStatusColor';
import formatDate from '../../../../Hooks/formatDate';

const PrintCustomerOrderReport = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const startDate = queryParams.get('startDate');
    const endDate = queryParams.get('endDate');
    const keyID = queryParams.get('outlet');

    const { data: Report, isSuccess, isLoading, isFetching, isError } = useCustomerOrderReportQuery({
        startDate,
        endDate,
        keyID,
    }, { skip: !startDate })


    const outletList = useOutletsQuery()
    const statusList = useStatusQuery()
    const outlet = keyID && outletList?.data?.data.find((elem) => (elem.outletId === Number(keyID)))
    const outletName = outlet?.outletName || ''



    useEffect(() => {
           const sidebar = document.querySelector('aside.sidenav');
           const mainContent = document.querySelector('.sidenav.fixed-start + .main-content');
           const navbar = document.querySelector('.navbar-main');
         
           if (sidebar) sidebar.style.display = 'none';
           if (mainContent) mainContent.style.marginLeft = '0';
           if (navbar) navbar.style.display = 'none';
         }, []);

    useEffect(() => {
        if (isSuccess && outletList.isSuccess) {
            // Open print dialog on success
            window.print();

            // Close the page when the print dialog is closed
            const handleAfterPrint = () => {
                window.close();
            };

            window.addEventListener('afterprint', handleAfterPrint);

            return () => {
                window.removeEventListener('afterprint', handleAfterPrint);
            };
        }
    }, [isSuccess, outletList.isSuccess, window]);

    if (!isSuccess) {
        return null;
    }

    return (
        <div className='card' id="invoice">
            <div className="card-body p-0">
                <div className="page-wrapper" style={{ padding: 15 }}>
                    {isError && <Error />}
                    {(isLoading || isFetching) && <Loader height="300px" />}
                    {(!isLoading && !isFetching) && (
                        <>
                            <table className='table table-borderless align-items-center mb-3 table-sm border-0'>
                                <tbody>
                                    <tr>
                                        <td className='px-0 border-0'>
                                            <p className='text-xs mb-0 text-dark'>Start Date</p>
                                            {formatDate(startDate)}
                                        </td>
                                        <td className='px-0 border-0'>
                                            <p className='text-xs mb-0 text-dark'>End Date</p>
                                            {formatDate(endDate)}
                                        </td>
                                        {
                                            keyID && (
                                                <td className='px-0 border-0'>
                                                    <p className='text-xs mb-0 text-dark'>Outlet</p>
                                                    {outletName}
                                                </td>
                                            )
                                        }
                                    </tr>
                                </tbody>
                            </table>

                            <div className="mb-4">
                                <table className="table table-bordered align-items-center mb-0">
                                    <thead className="bg-light">
                                        <tr>
                                            <th className="text-uppercase text-secondary text-xs opacity-7 px-2 text-wrap" style={{maxWidth: 50}}>Date</th>
                                            <th className="text-uppercase text-secondary text-xs opacity-7 px-2 text-wrap" style={{maxWidth: 50}}>Order Id</th>
                                            <th className="text-uppercase text-secondary text-xs opacity-7 px-2 text-wrap" style={{maxWidth: 100}}>Customer Details</th>
                                            <th className="text-uppercase text-secondary text-xs opacity-7 px-2 text-wrap" style={{maxWidth: 50}}>Order Amount</th>
                                            <th className="text-uppercase text-secondary text-xs opacity-7 px-2 text-wrap" style={{maxWidth: 50}}>Paid Amount</th>
                                            <th className="text-uppercase text-secondary text-xs opacity-7 px-2 text-wrap" style={{maxWidth: 50}}>Outlet Name</th>
                                            <th className="text-uppercase text-secondary text-xs opacity-7 px-2 text-wrap" style={{maxWidth: 50}}>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Report.data.orderDetails.length > 0 ? Report.data.orderDetails.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-xs px-2" style={{maxWidth: 50}}>{formatDate(item.date)}</td>
                                                <td className="text-xs px-2" style={{maxWidth: 50}}>{item.orderId}</td>
                                                <td className="text-xs px-2" style={{maxWidth: 100}}>
                                                    <p className='text-xs mb-0 fw-600 text-wrap' style={{maxWidth: 100}}>{item.customerName}</p>
                                                    <p className='text-xs mb-0 text-wrap' style={{maxWidth: 100}}>{item.customerPhone}</p>
                                                    <p className='text-xs mb-0 text-wrap' style={{maxWidth: 100}}>{item.customerEmail}</p>
                                                    <p className='text-xs mb-0 text-wrap' style={{maxWidth: 100}}>{item.customerAddress}</p>
                                                </td>
                                                <td className="text-xs px-2" style={{maxWidth: 50}}>R {item.orderAmount.toFixed(2)}</td>
                                                <td className="text-xs px-2" style={{maxWidth: 50}}>R {item.paidAmount.toFixed(2)}</td>
                                                <td className="text-xs px-2 text-wrap" style={{maxWidth: 50}}>{item.outletName}</td>
                                                <td className="text-xs px-2 text-wrap" style={{maxWidth: 50}}>
                                                    <span
                                                        type="button"
                                                        className={`text-wrap badge badge-sm text-uppercase badge-${getStatusColor(item.statusName)}`}
                                                        style={{ cursor: "default" }}
                                                    >
                                                        {item.statusName}
                                                    </span>
                                                </td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan={7} className='text-center py-5'>No Data Found !!</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="row align-items-center mb-3">
                                <div className="col-md-3">
                                    <span className="text-xs mb-0 fw-500">Orders:</span>
                                    <span className="text-xs text-dark ms-2 fw-600 mb-0">{Report?.data?.totalOrders}</span>
                                </div>
                                <div className="col-md-4">
                                    <span className="text-xs mb-0 fw-500">Order Amount:</span>
                                    <span className="text-xs text-dark ms-2 fw-600 mb-0">R {Report?.data?.totalOrderAmount}</span>
                                </div>
                                <div className="col-md-4">
                                    <span className="text-xs mb-0 fw-500">Received Amount:</span>
                                    <span className="text-xs text-dark ms-2 fw-600 mb-0">R {Report?.data?.totalReceivedAmount}</span>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PrintCustomerOrderReport;
